if (window && window.__webpack_asset_path) { //eslint-disable-line
    __webpack_public_path__ = window.__webpack_asset_path; //eslint-disable-line
}

import 'console-shim';
import root from 'window-or-global';
import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import ScrollToTopOnUpdate from 'epic-react-common/src/components/ScrollToTopOnUpdate';
import {setLocale} from 'epic-common/src/locale';
import App from './App';
import alt from './alt';

const reactDomEle = document.getElementById('odinReactWrapper');

// only proceed if the react ele exists
if (reactDomEle) {
    if (root.__epic_client_state) {
        setLocale(root.__locale);
        alt.bootstrap(root.__epic_client_state);
    }
    ReactDOM.hydrate(
        (
            <BrowserRouter>
                <ScrollToTopOnUpdate>
                    <App />
                </ScrollToTopOnUpdate>
            </BrowserRouter>
        ), reactDomEle
    );
}
